module.exports = __webpack_public_path__ + "static/img/20045B_5_6_C_20240425_LC.000dd57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_5_6_C_20240425_LC.png
// module id = R6HQ
// module chunks = 0